// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CvssModifiedAttackComplexitySchema = z.enum(['X','L','H'] as const);

export type CvssModifiedAttackComplexityType = `${z.infer<typeof CvssModifiedAttackComplexitySchema>}`

export default CvssModifiedAttackComplexitySchema;
